// import React from "react";

// const VisionMissionAimSection = () => {
//   return (
//     <section className="bg-[#F9FBFF] py-20">
//       <div className="container mx-auto px-6 lg:px-16">
//         {/* Section Header */}
//         <div className="text-center mb-16">
//           <h2 className="text-4xl md:text-5xl font-extrabold text-[#0B1D33] mb-4">
//             Where <span className="text-[#4FB1FF]">Vision</span> Meets{" "}
//             <span className="text-[#FFD700]">Action</span>
//           </h2>
//           <p className="text-gray-600 max-w-3xl mx-auto text-lg leading-relaxed">
//             As pioneers of this innovative initiative, we are committed to
//             unlocking the immense potential of collaborative ventures between
//             two of the world's most historically rich and diverse regions.
//           </p>
//         </div>

//         {/* Mission Section */}
//         <div className="grid lg:grid-cols-2 gap-10 items-center mb-20">
//           <img
//             src="/HomePage/mission.jpg"
//             alt="Our Mission"
//             className="rounded-2xl shadow-lg object-cover w-full h-[240px]"
//           />
//           <div>
//             <h3 className="text-3xl font-bold text-[#0B1D33] mb-4">
//               Our Mission
//             </h3>
//             <p className="text-gray-700 mb-6 leading-relaxed">
//               Comprising a dynamic council of forward-thinking professionals,
//               the Indo European Business Council is dedicated to advancing the
//               interests of businesses—large or small, established or
//               emerging—not only within India and Europe but across the global
//               stage.
//             </p>
//             <p className="text-gray-700 leading-relaxed">
//               Our approach is both comprehensive and integrative. We believe the
//               pulse of Indo European collaboration isn’t just felt in formal
//               boardrooms—it resonates in local markets, digital platforms,
//               academic exchanges, policy dialogues, and everyday entrepreneurial
//               resilience.
//             </p>
//             <button className="mt-6 bg-[#4FB1FF] text-white px-6 py-3 rounded-lg font-semibold shadow-md hover:bg-[#3A93D9] transition">
//               Find Out More
//             </button>
//           </div>
//         </div>

//         {/* Vision Section */}
//         <div className="grid lg:grid-cols-2 gap-10 items-center mb-20 lg:flex-row-reverse">
//           <div>
//             <h3 className="text-3xl font-bold text-[#0B1D33] mb-4">
//               Our Vision
//             </h3>
//             <p className="text-gray-700 leading-relaxed mb-6">
//               By fostering these multifaceted connections, the Indo European
//               Business Council doesn’t just strengthen individual businesses—it
//               embeds economic cooperation into the very fabric of our societies,
//               paving the way for long-term, cross-border impact.
//             </p>
//             <p className="text-gray-700 leading-relaxed">
//               We envision a world where India and Europe operate not as distant
//               markets but as interconnected ecosystems driving inclusive growth,
//               innovation, and prosperity.
//             </p>
//             <button className="mt-6 bg-[#4FB1FF] text-white px-6 py-3 rounded-lg font-semibold shadow-md hover:bg-[#3A93D9] transition">
//               Find Out More
//             </button>
//           </div>
//           <img
//             src="/HomePage/vission.jpg"
//             alt="Our Vision"
//             className="rounded-2xl shadow-lg object-cover w-full h-[240px]"
//           />
//         </div>

//         {/* Aim Section */}
//         <div className="grid lg:grid-cols-2 gap-10 items-center">
//           <img
//             src="/HomePage/aim.jpg"
//             alt="Our Aim"
//             className="rounded-2xl shadow-lg object-cover w-full h-[240px]"
//           />
//           <div>
//             <h3 className="text-3xl font-bold text-[#0B1D33] mb-4">Our Aim</h3>
//             <p className="text-gray-700 leading-relaxed mb-4">
//               <strong>Empowering Businesses for a Resilient Future</strong>
//             </p>
//             <p className="text-gray-700 leading-relaxed mb-6">
//               In today’s volatile global marketplace, the concept of “Empowered
//               Businesses” is not just a goal—it is a necessity. Indo European Business Council is
//               steadfastly committed to fostering an ecosystem where businesses
//               are:
//             </p>
//             <ul className="list-disc list-inside text-gray-700 mb-6 space-y-2">
//               <li>Economically resilient</li>
//               <li>Technologically agile</li>
//               <li>Socially responsible</li>
//               <li>Collaboratively connected</li>
//             </ul>
//             <p className="text-gray-700 leading-relaxed">
//               We envision a business landscape where startups and corporates
//               alike thrive together, elevating the economies of our nations and
//               shaping a sustainable global future.
//             </p>
//             <button className="mt-6 bg-[#4FB1FF] text-white px-6 py-3 rounded-lg font-semibold shadow-md hover:bg-[#3A93D9] transition">
//               Learn More
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default VisionMissionAimSection;

import React from "react";

// Use public domain or free Icons8 PNG icons
const icons8Icons = [
  {
    title: "Mission",
    desc: "Advance the interests of businesses across India, Europe, and globally through strategic collaboration.",
    iconUrl:
      "https://img.icons8.com/color/48/target--v1.png", // Target icon
    color: "#4FB1FF",
  },
  {
    title: "Vision",
    desc: "Foster long-term cross-border impact by connecting businesses and societies for inclusive growth.",
    iconUrl:
      "https://img.icons8.com/color/48/visible--v1.png", // Eye/View icon
    color: "#FFD700",
  },
  {
    title: "Aim",
    desc: "Empower businesses to be resilient, agile, responsible, and connected in today’s global market.",
    iconUrl:
      "https://img.icons8.com/color/48/conference-call--v1.png", // Users/group icon
    color: "#FF6B6B",
  },
];

const VisionMissionAimSection = () => {
  return (
    <section className="bg-[#F9FBFF] py-20">
      <div className="container mx-auto px-6 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-extrabold font-Agatho_Regular text-[#0B1D33] mb-4">
            Where <span className="text-[#4FB1FF]">Vision</span> Meets{" "}
            <span className="text-[#FFD700]">Action</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg leading-relaxed">
            Driving impactful Indo European business collaborations with
            clarity, innovation, and purpose.
          </p>
        </div>

        {/* Cards */}
        <div className="flex flex-col lg:flex-row gap-8">
          {icons8Icons.map((section, i) => (
            <div
              key={i}
              className="flex-1 bg-white rounded-2xl shadow-md hover:shadow-xl transition p-8 flex flex-col items-start gap-4"
            >
              <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-full mb-4">
                <img
                  src={section.iconUrl}
                  alt={section.title + " icon"}
                  style={{ width: 32, height: 32, filter: "none" }}
                />
              </div>
              <h3 className="text-3xl font-Agatho_Regular font-semibold text-[#0B1D33]">
                {section.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">{section.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VisionMissionAimSection;
